import { Link } from 'react-router'
import styles from './LanguageSwitchBar.module.scss'
import { useStoreSelector } from 'hooks/store'
import { LanguageSwitchBarProps } from './types'
import { getUserTypeHomepage } from 'utils/user'
import LanguageSwitchButton from 'components/language-switch-button/LanguageSwitchButton'
import classNames from 'classnames'
import Logo from 'assets/Logo.tsx'
import { Icon } from '@boltenergy-be/design-system'

const LanguageSwitchBar = ({ redirectUrl, compact, sticky, collapsed }: LanguageSwitchBarProps) => {
  // REDUX STORE
  const { userType } = useStoreSelector((store) => store.auth)

  return (
    <nav
      className={classNames(styles['language-switch-bar'], {
        [styles.compact]: compact,
        [styles.sticky]: sticky,
        [styles.collapsed]: collapsed
      })}
    >
      <Link to={redirectUrl || getUserTypeHomepage(userType)}>{collapsed ? <Icon name="boltLogo" /> : <Logo />}</Link>
      <LanguageSwitchButton withIcon={!collapsed} />
    </nav>
  )
}

export default LanguageSwitchBar
